module.exports = __webpack_public_path__ + "img/ico-report.abd98de5.svg";